import { Component, OnInit, Inject } from '@angular/core';
import { Guide } from '@model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-guide',
    templateUrl: './guide.component.html',
    standalone: false
})
export class GuideComponent implements OnInit {
  guide: Guide;
  pageNumber = 0;

  constructor(public dialogRef: MatDialogRef<GuideComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    // Clone the object
    this.guide = { ...this.data, pages: this.data.pages.map(p => ({ ...p })) };

    // Sort pages
    this.guide.pages.sort((a, b) => {
      return this.compare(a.step, b.step, true);
    });
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  onCancel() {
    this.dialogRef.close();
  }

  nextPage() {
    if (this.pageNumber < this.guide.pages.length - 1) {
      this.pageNumber = this.pageNumber + 1;
    }
  }

  prevPage() {
    if (0 < this.pageNumber) {
      this.pageNumber = this.pageNumber - 1;
    }
  }

  pageChange(event: any) {
    this.pageNumber = event.selectedIndex;
  }
}
